import http from '@/requests/http'

class WorkTime {
  static check (params) {
    return http.post('work-time/check', params)
  }
  static on (params) {
    return http.post('work-time/on', params)
  }
  static off (params) {
    return http.post('work-time/off', params)
  }
}

export default WorkTime
